import React, { useContext, useEffect, useState } from 'react'

//interfaces
import { ITableColumn, ITableContent, ITableRows } from  '@/interfaces/simpleTable';
import { AllUsersSortByType } from  '@/interfaces/orgSettings';
import { SortBy } from  '@/interfaces/toggle';

//components
import GroupIconsAndName from  '@/components/elements/orgSettings/tableCellItems/GroupIconsAndName';
import FixedPositionPermissionDropdown from  '@/components/elements/global/dropdown/FixedPositionPermissionDropdown';

//context
import { OrgSettingsContext } from '@/context/OrgSettings';

//api
import { OrgSettingsWorkspaceContext } from '@/context/OrgSettingsWorkspaceContext';

//helpers
import { isExternallyManaged } from  '@/helpers/OrgSettings';



const UseAddNewUserGroupModal = (showModal: boolean) => {  
    const {workspaceName} = useContext(OrgSettingsContext);
    const {removeUserGroupFromWorkspace, setUserGroupWorkspacePermission, setModalSortToggle, getNewUserGroups, newUserGroupData, moreAvailable, modalSortToggle, newUsersIsLoading, searchNewGroupString, setSearchNewGroupString } = useContext(OrgSettingsWorkspaceContext);
    const [tableContent, setTableContent] = useState<ITableContent>(); 

    const headerText = `Add Group to ${workspaceName}`;
    const noDataMessage = "No User Groups Available";
    const closeButtonText = "Close";
    const searchInputLabel = "Filter user groups with search input";
    const columns: ITableColumn[] = [
        { title: "Groups", isToggleButton: true, onSortAscendingClick: () => toggleSort(AllUsersSortByType.GROUPS, SortBy.DESCENDING), onSortDescendingClick: () => toggleSort(AllUsersSortByType.GROUPS, SortBy.ASCENDING), defaultSort: SortBy.ASCENDING },
        { title: "Members", isToggleButton: true, onSortAscendingClick: () => toggleSort(AllUsersSortByType.MEMBERS, SortBy.ASCENDING), onSortDescendingClick: () => toggleSort(AllUsersSortByType.MEMBERS, SortBy.DESCENDING) }, 
        { title: "Permissions", isToggleButton: false },
    ];

    useEffect(() => {
       if (showModal) {
            getNewUserGroups('new');
       } 
    },[showModal, modalSortToggle[0], modalSortToggle[1]]);

    useEffect(()=> {
        getNewUserGroups('new');
    }, [searchNewGroupString]);

    useEffect(() => {
        let rows: ITableRows[] = [];
        newUserGroupData?.forEach((userGroup) => {
            const row: ITableRows = {
                content: [
                    <GroupIconsAndName 
                        key={`name-and-pics-${userGroup.id}`} 
                        profilePictures={userGroup.profilePictureUrls} 
                        userGroupId={userGroup.id} 
                        userGroupName={userGroup.name} 
                        truncate={150} 
                        hasNoMembers={userGroup.totalMembers === 0}
                        isManagedGroup={isExternallyManaged(userGroup.groupManagementType)}
                        externalLoginIcon={userGroup.provider?.iconUrl}    
                    />,
                    userGroup.totalMembers,
                    <FixedPositionPermissionDropdown key={`permission-drop-down${userGroup.id}`} id={userGroup.id} setPermission={setUserGroupWorkspacePermission} removePermission={removeUserGroupFromWorkspace}/>,
                ]};
            rows.push(row);
        });
 
        setTableContent({rows: rows, columns: columns});
    }, [newUserGroupData]);

    function getMoreUserGroups(){
        getNewUserGroups('paginate');
    }

    function toggleSort(sortByType: AllUsersSortByType, sortBy: SortBy) {
        setModalSortToggle([sortByType, sortBy]);
    }

    return {headerText, noDataMessage, closeButtonText, getMoreUserGroups, tableContent, isLoading: newUsersIsLoading, moreAvailable, dataLength: newUserGroupData?.length ?? 0, searchNewGroupString, setSearchNewGroupString, searchInputLabel}
}

export default UseAddNewUserGroupModal